// extracted by mini-css-extract-plugin
module.exports =  {"main_block":"main_block___wpb2G","mainBlock":"main_block___wpb2G","aboutWrap":"aboutWrap___qYInq","points":"points___hTQan","content":"content___aB2sB","onlyHe":"onlyHe___IavKq"};